import { render, staticRenderFns } from "./ManageValidationReason.vue?vue&type=template&id=65df9e11&scoped=true"
import script from "./ManageValidationReason.vue?vue&type=script&lang=js"
export * from "./ManageValidationReason.vue?vue&type=script&lang=js"
import style0 from "./ManageValidationReason.vue?vue&type=style&index=0&id=65df9e11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df9e11",
  null
  
)

export default component.exports